import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Tooltip, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import _ from 'lodash';

import { formatNumberToCurrencyString } from 'utils/number';

import { selectUnderwritingQualificationDetails } from 'store/loanApplications/selectors';

import { notApplicable } from './QualificationDetails.constants';
import TooltipContent from './QualificationDetailsTooltip';

const wrapperStyles = {
  backgroundColor: theme =>
    theme.palette.type === 'dark' ? theme.palette.grey.A400 : theme.palette.common.white,
  borderRadius: '20px',
};

const QualificationDetails = () => {
  const { monthsInReserve, requiredReservesAmount, cashFromToBorrower, householdTotalAssets } =
    useSelector(selectUnderwritingQualificationDetails) || {};

  const textColor = _.gte(householdTotalAssets, _.sum([requiredReservesAmount, cashFromToBorrower]))
    ? 'text-green'
    : 'text-red';

  const requiredReservesAmountToDisplay = _.isNumber(requiredReservesAmount)
    ? formatNumberToCurrencyString(requiredReservesAmount)
    : notApplicable;

  const monthsInReserveValueToDisplay = _.isNumber(monthsInReserve)
    ? monthsInReserve
    : notApplicable;

  return (
    <>
      <Typography className="mb-20" variant="bold16">
        Qualifications details
      </Typography>

      <Box className="p-24 w-full" sx={wrapperStyles}>
        <div className="flex gap-10">
          <Typography className="self-center" variant="regular14">
            {`Required Reserves Amount: `}
            <span className={textColor}>{requiredReservesAmountToDisplay}</span>
          </Typography>

          <Tooltip placement="top" title={<TooltipContent />}>
            <InfoIcon />
          </Tooltip>
        </div>

        <Typography variant="regular14">
          {`Months Reserves: `}
          <span className={textColor}>{monthsInReserveValueToDisplay}</span>
        </Typography>
      </Box>
    </>
  );
};

QualificationDetails.propTypes = {
  ...WithLoadingPropTypes,
};

export default memo(QualificationDetails);
